<template>
    <form>
        <div class="mb-3">
            <v-text-field
                v-model="user.email"
                label="Διεύθυνση email"
                v-bind:error-messages="allerrors.email">
            </v-text-field>
        </div>
        <div class="mb-3">
             <v-text-field
                v-model="user.password"
                type="password"
                label="Κωδικός πρόσβασης"
                v-bind:error-messages="allerrors.password">
            </v-text-field>
        </div>
        <!--
        <div class="mb-3 form-check">
            <input type="checkbox" class="form-check-input" id="exampleCheck1">
            <label class="form-check-label" for="exampleCheck1">Check me out</label>
        </div>
        -->
        <button type="submit" class="btn btn-primary" @click.prevent="loginButtonClick">Είσοδος</button>
    </form>
</template>

<script>
export default {
    data: () => ({
        user: {
            email: "",
            password: ""
        },
        allerrors: {}
    }),

    methods: {
        loginButtonClick() {
            // this.$store.dispatch('currentUser/login', this.user)
            // this.$swal.fire('success', 'yay', 'success');
        
        axios.post("/api/login", {
            email: this.user.email,
            password: this.user.password
        })
        .then(response => {
            if (response.data.token) {
                localStorage.setItem('access-token', response.data.token)
             
                window.location.replace("/home")
            }
        })
        .catch(error => {
            console.log('login error')
            // console.log(error)
            this.$swal.fire('Σφάλμα', 'Λάθος όνομα χρήστη ή/και κωδικός πρόσβασης', 'error')
        })
        }
    }
}
</script>

